import './style.scss';
import Input from "../../components/common/input";
import React, {useState} from "react";
import DistrictForm from "../../components/districtForm";
import {saveDistrict, clearEditDistrictErrors} from "../../actions/districts";
import {useDispatch, useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import Alert from "../../components/common/alert";

export const route = 'edit-district';

const EditDistrict = () => {
  const shouldLockForm = false;
  const errors = useSelector((state) => state.districts.editDistrictErrors);
  const editDistrictAlert = useSelector((state) => state.districts.editDistrictAlert);
  const editDistrictApiError = useSelector((state) => state.districts.editDistrictApiError);
  const district = useSelector((state) => state.districts.currentDistrict);
  const [name, setName] = useState(district.name);
  const [externalId, setExternalId] = useState(district.externalId);

  const dispatch = useDispatch();

  const onDismissAlert = () => {
    dispatch(clearEditDistrictErrors());
  }

  const submitSaveDistrict = () => {
    const districtForm = {
      name: name,
      externalId: externalId
    }

    dispatch(saveDistrict(districtForm, district));
  }

  return (editDistrictAlert) ? <Navigate to='/manage-schools' /> : (
    <div className='main-content'>
      <div className='edit-district-header'>Edit District</div>
      <div className='edit-district-alerts'>
        {(editDistrictApiError) && <Alert onDismiss={onDismissAlert}>{editDistrictApiError}</Alert>}
      </div>
      <div className='edit-district-container'>
        <DistrictForm
          submitLabel='Submit'
          submitAction={() => {submitSaveDistrict()}}
          disabled={shouldLockForm}
        >

          <Input
            name='name'
            id='name'
            value={name}
            label='District Name*'
            type='text'
            changeAction={setName}
            errors={errors?.name}
          />

          <Input
            name='externalId'
            id='externalId'
            value={externalId}
            label='External ID*'
            type='text'
            changeAction={setExternalId}
            errors={errors?.externalId}
          />
        </DistrictForm>
      </div>
    </div>
  );
}

export default EditDistrict;